// extracted by mini-css-extract-plugin
module.exports = {"starterKit":"starterKit1_starterKit__n4d0q"};